module.exports = __webpack_public_path__ + "img/googlehome_small.cbe16b09.png";